import { Loader } from '@googlemaps/js-api-loader';
import { MarkerClusterer, SuperClusterAlgorithm } from '@googlemaps/markerclusterer';

import { MapOptionsInfo, MarkerManaged, MarkerInfo, MakerCoordenate, EventPositionMarker, EventClickMarker,ContentWindowInfo , CoordenateInfo} from './interfaces';

//Manejador avanzador de mapas
//Contiene los callback para atender los eventos
export class MarkersManager 
{
    public version: string ='MarkersManager.v202607061629';

    private markerClusterer: MarkerClusterer | null = null;
    public clusterable: boolean = false;
    public isLoadingMarkers: boolean = false;
    
    public markers = new Map<string, MarkerManaged>();

    public map: google.maps.Map | null = null;    
    private currentInfoWindow: google.maps.InfoWindow | null = null;
    private initPromise: Promise<void>|null=null ;

    //callbacks para ser asignados a los marker 
    public draggendCallback?: (eventPosition:EventPositionMarker) => void;
    public clickMarkerCallback?: (eventClickMarker:EventClickMarker) => void;
   
    constructor(isClusterable:boolean) 
    {
        this.clusterable=isClusterable;
        
    }

    public SetMap(map: google.maps.Map):void
    {
        this.map = map;
        
        if(!this.map) return;

        map.addListener('click', () => {
            this.closeCurrentInfoWindow();
        });

        /*
        map.addListener('zoom_changed', () => {
            this.closeCurrentInfoWindow();
        });
        */
        if(this.clusterable)
        {
            this.markerClusterer = new MarkerClusterer({
                map:this.map,
                algorithm: new SuperClusterAlgorithm({
                    radius: 100, // Radio de agrupación en píxeles
                    maxZoom: 15  // Zoom máximo para agrupar                   
                })
            });
        } 

        /*
        if(this.markerClusterer)
        {
            google.maps.event.addListener(this.markerClusterer, 'clusteringbegin', () => {
                this.closeCurrentInfoWindow();
            });
        }
        */
    }

    public GetMarkerInfo(id: string): MarkerInfo | undefined
    {
        const markerManaged = this.markers.get(id);
    
        if (!markerManaged || !markerManaged.marker) return undefined;
    
        const position = markerManaged.marker.position;
    
        return {
            id: markerManaged.id,
            position: {
                lat: typeof position?.lat === 'function' ? position.lat() : position?.lat||0,
                lng: typeof position?.lng === 'function' ? position.lng() : position?.lng||0
            },
            title: markerManaged.marker.title || '',
            address: markerManaged.address,
            draggable: markerManaged.marker.gmpDraggable || false,
            callable: markerManaged.marker.gmpClickable || false,
            geocodable: markerManaged.geocodable || false,
            icon: ''
        };
    }

    public async AddMarkerAsync( markerInfo: MarkerInfo): Promise<void>    
    {
        const marker = new google.maps.marker.AdvancedMarkerElement(
        {
            map: this.isLoadingMarkers ? null : this.map,
            position: markerInfo.position,
            content: this.CreateCustomIcon(markerInfo.icon || 'default-icon.png' , markerInfo.title || ''   ),
            title: 'Arrastra para mover' ,
            gmpDraggable: markerInfo.draggable || false,
            gmpClickable: markerInfo.callable || false 
        });

        let markerManaged:MarkerManaged=
        {
            id: markerInfo.id, 
            marker: marker, 
            address:  '',
            geocodable: markerInfo.geocodable || false,
            draggable: markerInfo.draggable || false,
            callable: markerInfo.callable || false,
            toCenter: markerInfo.toCenter || false
        }

        this.markers.set(markerInfo.id, markerManaged);

        if(markerManaged.draggable)
        {
            this.AddDragListener(markerManaged.id);
        }

        if( markerManaged.callable  )
        {
            this.AddMarkerClickListener( markerManaged.id );
        }

        if( this.clusterable && this.markerClusterer)
        {
            this.markerClusterer.addMarker(marker);
        }

        if( markerManaged.geocodable )
        {
            let makerInfoGeocoded=await this.GeocodeAddressAsync(markerManaged, markerInfo);
            markerManaged.address=makerInfoGeocoded.address;
            if(markerManaged.marker!=null)
            {
                markerManaged.marker.position={ lat: makerInfoGeocoded.position.lat, lng: makerInfoGeocoded.position.lng };
            }
        }

        if(markerInfo.toCenter)
            this.CenterMapIntoMarker(markerManaged);
    }

    public async UpdateMarkerAsync( markerInfo: MarkerInfo): Promise<void>
    {
        if(!this.markers) return;
        
        const markerManaged = this.markers.get(markerInfo.id);

        if (markerManaged == null) return; 
        
        //actualiza la direccion y el gps
        let makerInfoGeocoded=await this.GeocodeAddressAsync(markerManaged, markerInfo);
        markerManaged.address=makerInfoGeocoded.address;
        if(markerManaged.marker!=null)
            markerManaged.marker.position={ lat: makerInfoGeocoded.position.lat, lng: makerInfoGeocoded.position.lng };

        if(markerManaged.toCenter)
            this.CenterMapIntoMarker(markerManaged);
    }

    public ShowAllMarkers(): void
    {
        this.markers.forEach((markerManaged) => {
            if (markerManaged.marker) {
                markerManaged.marker.map = this.map;
            }
        });
    }

    private async GeocodeAddressAsync(markerManaged: MarkerManaged, newValueMarker: MarkerInfo):Promise<MarkerInfo>
    {
        if(!this.map) return newValueMarker;

        const hasAdress = newValueMarker.address && newValueMarker.address.trim().length!==0;
        const hasAddressChanged = markerManaged.address !== newValueMarker.address ;

        const hasCoordsCero = !newValueMarker.position || (newValueMarker.position.lat===0 && newValueMarker.position.lng==0) ;

        //resolver si tiene dirección nueva,y cambio o no tiene coordeandas y es geocodable
        const resolvCoords = hasAdress && ( hasAddressChanged || hasCoordsCero) && newValueMarker.geocodable;

        if(!resolvCoords) return newValueMarker;
        
        const geocoder = new google.maps.Geocoder();
        const results = await geocoder.geocode({ address: newValueMarker.address });

        let isCoordChanged=false;
        if (results.results.length > 0) 
        {
            const location = results.results[0].geometry.location;
            const newPos = { lat: location.lat(), lng: location.lng() };
            if(markerManaged.marker)
            {
                newValueMarker.position = newPos;
                isCoordChanged=true;
            }
        }

        if( isCoordChanged &&  markerManaged.draggable===true && this.draggendCallback && this.draggendCallback instanceof Function )
        {
            this.draggendCallback({ id: newValueMarker.id, position: {lat:newValueMarker.position.lat, lng:newValueMarker.position.lng} });
        }

        return newValueMarker;
    }

    private CenterMapIntoMarker(markerManaged: MarkerManaged): void
    {
        if( this.map && markerManaged.marker && markerManaged.marker.position )
        {
            this.map?.setCenter(markerManaged.marker.position);
        }
    }

    public RemoveMarker(id: string): void 
    {
        const marker = this.markers.get(id);
        if (marker &&  marker.marker ) 
        {
            this.RemoveDragListener(id);  
            marker.marker.map = null;
            this.markers.delete(id);
        }
    }

    AddDragListener(id: string): void 
    {
        const marker = this.markers.get(id);

        console.log(`---> ${id}`);

        if (!marker || !marker.marker) return;
           
        marker.marker.addListener('dragend', () => 
        {
            const pos = marker.marker?.position;

            if (this.draggendCallback  && pos )
            {
                const lat = typeof pos.lat === 'function' ? pos.lat() : pos.lat;
                const lng = typeof pos.lng === 'function' ? pos.lng() : pos.lng;
                this.draggendCallback({ id: marker.id,  position: { lat:lat, lng:lng }});
            }
        });
    }

    RemoveDragListener(id: string): void 
    {
        if (!this.markers) return;
        
        const marker = this.markers.get(id);
        if (!marker) return;
        
        marker?.marker?.removeEventListener('dragend',  () => {});
        this.draggendCallback = undefined;        
    }

    AddMarkerClickListener(id: string): void 
    {
        if(!this.markers) return;
        if(!this.clickMarkerCallback) return;

        const marker = this.markers.get(id);

        if (!marker ||  !marker.marker ) return;
           
        marker.marker.addListener('gmp-click', () => 
        {
            if (this.clickMarkerCallback) 
            {
                this.clickMarkerCallback({ id: marker.id })
            }
        });        
    }

    RemoveMarkerClickListener(id: string, callback: (pos: google.maps.LatLngLiteral) => void): void 
    {
        if (!this.markers) return;

        const marker = this.markers.get(id);
        if (!marker ) return;

        marker.marker?.removeEventListener('click',  () => {});
        this.clickMarkerCallback = undefined;
    }

    private CreateCustomIcon(iconUrl: string, label?: string): HTMLElement 
    {
        const container = document.createElement('div');
        container.style.position = 'relative';
        container.style.display = 'inline-block';
        
        const markerImage = document.createElement('img');
        markerImage.src = iconUrl; 
        markerImage.style.width = '32px';
        markerImage.style.height = '32px';
        
        container.appendChild(markerImage);
        
        if (label) 
        {
            const labelElement = document.createElement('div');
            labelElement.textContent = label;
            labelElement.style.position = 'absolute';
            labelElement.style.top = '-5px';
            labelElement.style.left = '50%';
            labelElement.style.transform = 'translateX(-50%)';
            labelElement.style.backgroundColor = 'white';
            labelElement.style.padding = '2px 6px';
            labelElement.style.borderRadius = '3px';
            labelElement.style.fontSize = '11px';
            labelElement.style.fontWeight = 'bold';
            labelElement.style.whiteSpace = 'nowrap';
            labelElement.style.boxShadow = '0 2px 4px rgba(0,0,0,0.2)';
            
            container.appendChild(labelElement);
        }
        
        return container;        
    }

    public ShowInfoWindow(contentInfoWindow:ContentWindowInfo): void
    {
        if(!this.map) return;

        const marker = this.markers.get(contentInfoWindow.id);   

        if (marker && this.map)
        {
            this.closeCurrentInfoWindow();            

            if(!this.currentInfoWindow)
            {
                //this.currentInfoWindow = new google.maps.InfoWindow({ content: contentInfoWindow.content,
                //                                                pixelOffset: new google.maps.Size(0, -10) });
                    
                this.currentInfoWindow = new google.maps.InfoWindow({ 
                    content: contentInfoWindow.content,
                    //pixelOffset: new google.maps.Size(0, -10),
                   // disableAutoPan: false // evitar pan prematuro antes de que el DOM exista
                });

                /*
                google.maps.event.addListenerOnce(this.currentInfoWindow, 'domready', () => {
                    MarkersManager._ensureInfoWindowStyles();  // DOM ya existe → estilos aplicados
                    this._restoreAutoPan(marker.marker!); // Ajustar pan después de que el DOM esté listo
                });

                google.maps.event.addListener(this.currentInfoWindow, 'closeclick', () => {
                    this.currentInfoWindow = null;
                });
                */
            }

            this.currentInfoWindow.open(this.map, marker.marker);
            
            this.currentInfoWindow.setZIndex(105); // Asegurar que el InfoWindow esté por encima de los marcadores y clusters
            // MarkersManager._ensureInfoWindowStyles();

             /*
             if(marker.marker)
                this._restoreAutoPan(marker.marker); 
             */
        }   
    }

    private static _ensureInfoWindowStyles(): void 
    {
        const styleId = 'gm-infowindow-zfix';
        if (document.getElementById(styleId)) return;
        
        const style = document.createElement('style');
        style.id = styleId;
        style.textContent = `
            // Fix z-index negativo que Google Maps asigna al wrapper del InfoWindow 
            .gm-style > div[style*="z-index: -2"],
            .gm-style > div[style*="z-index:-2"] {
                z-index: 105 !important;
            }
            
            // Fix fondo transparente 
            .gm-style-iw-c {
                background-color: #fff !important;
            }
            .gm-style-iw-d {
                background-color: #fff !important;
            }
            .gm-style-iw-chr {
                background-color: #fff !important;
            }
        `;
        document.head.appendChild(style);
    }

    private _restoreAutoPan(marker: google.maps.marker.AdvancedMarkerElement): void
    {
        if (!this.map || !marker.position) return;

        const mapDiv = this.map.getDiv();
        const mapRect = mapDiv.getBoundingClientRect();

        const iw = document.querySelector<HTMLElement>('.gm-style-iw-a');
        if (!iw) return;

        const iwRect = iw.getBoundingClientRect();

        // Calcular cuánto sobresale el InfoWindow fuera del área visible del mapa
        const overflowTop    = mapRect.top  - iwRect.top    + 10;
        const overflowRight  = iwRect.right - mapRect.right + 10;
        const overflowBottom = iwRect.bottom - mapRect.bottom + 10;
        const overflowLeft   = mapRect.left - iwRect.left   + 10;

        const panX = overflowRight  > 0 ? overflowRight
                : overflowLeft   > 0 ? -overflowLeft
                : 0;

        const panY = overflowTop    > 0 ? -overflowTop
                : overflowBottom > 0 ? overflowBottom
                : 0;

        if (panX !== 0 || panY !== 0)
            this.map.panBy(panX, panY);
    }

    public closeCurrentInfoWindow(): void 
    {
        if (this.currentInfoWindow) 
        {
            google.maps.event.clearInstanceListeners(this.currentInfoWindow);
            this.currentInfoWindow.close();
            this.currentInfoWindow.setPosition(null as any); // ← rompe la asociación de posición
            google.maps.event.clearInstanceListeners(this.currentInfoWindow);
           this.currentInfoWindow = null;
        }
    }

    public async DisposeAsync(): Promise<void>
    {
        try 
        {
            this.closeCurrentInfoWindow();

            if(this.markers)
            {
                this.markers.forEach((marker) => {
                    if(marker.marker) 
                    {
                        google.maps.event.clearInstanceListeners(marker.marker);
                        marker.marker.map = null;
                    }
                });
                this.markers.clear();
            }

            if(!this.map) return;
            this.map=null;
        } 
        catch (error) 
        {
            console.error('Error disposing map:', error);
            throw error;
        }
    }
}


